import React from 'react';
import { Popover} from 'reactstrap';

import { connect } from 'react-redux'
import ExitToAppOutlined from '@mui/icons-material/ExitToAppOutlined';
import { logoutUser } from '../../reducers/actions';

class UserPopoverItem extends React.Component {
  constructor(props) {
    super(props);
  }


  componentDidUpdate(prevProps) {

  }


  logout = () => {
    this.props.dispatch(logoutUser());
  }

  render() {
    //seperate style for hidden input.
    var style = {};
    style.display = 'none';
    let popoverItems = []

    popoverItems.push(
      <a class="s-list-default-btn-default s-popup-menu-no-icon" title="Logout" onClick={this.logout}>
        <div class="s-list-default-btn-default-icon s-mn-icontext">
          <ExitToAppOutlined fontSize={"small"} style={{ position: "relative", display: "inline-block", color: '#3c424f' }} />
        </div>
        <p style={{ verticalAlign: "top", position: "relative", display: "inline-block", color: '#3c424f' }}>Logout</p>
      </a>
    );

    return (
      <span>
        <Popover placement="bottom" hideArrow={true} isOpen={this.props.visible} target="UserProfile" toggle={this.toggle}>
          {popoverItems}
        </Popover>
      </span>
    );
  }
}

export default connect(state => state)(UserPopoverItem);